import styled from '@emotion/styled';
import { devices } from '../assets/visual/responsive/breakpoints';

const Cover = styled.div`
	font-family: Cover;
	font-size: 8vw;
	text-align: center;
	color: #005b96;
	@media ${devices.mobileL} {
		font-size: 50px;
	}
`;

const Profile = styled.div`
	font-family: Profile;
	font-size: 3.5vw;
	color: #3e4756;
	white-space: pre-line;
	a {
		background: linear-gradient(to bottom, #ff9800 0%, #ff9800 100%);
		background-position: 0 100%;
		background-repeat: repeat-x;
		background-size: 6px 6px;
		color: #3e4756;
		text-decoration: none;
		&:hover {
			background-image: url("data:image/svg+xml;charset=utf8,%3Csvg id='squiggle-link' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' xmlns:ev='http://www.w3.org/2001/xml-events' viewBox='0 0 20 4'%3E%3Cstyle type='text/css'%3E.squiggle{animation:shift .3s linear infinite;}@keyframes shift {from {transform:translateX(0);}to {transform:translateX(-20px);}}%3C/style%3E%3Cpath fill='none' stroke='%23ff9800' stroke-width='2' class='squiggle' d='M0,3.5 c 5,0,5,-3,10,-3 s 5,3,10,3 c 5,0,5,-3,10,-3 s 5,3,10,3'/%3E%3C/svg%3E");
			background-size: auto 12px;
		}
	}
	@media ${devices.mobileL} {
		font-size: 20px;
	}
`;

const Position = styled.div`
	font-family: Profile;
	font-size: 5vw;
	color: #3e4756;
	@media ${devices.mobileL} {
		font-size: 25px;
	}
`;

const Title = styled.div`
	font-family: Title;
	font-size: 4vw;
	color: #0036af;
	@media ${devices.mobileL} {
		font-size: 30px;
	}
	@media ${devices.mobileM} {
		font-size: 25px;
	}
`;

const Description = styled.div`
	font-family: Description;
	font-size: ${props => (props.strong ? '2vw' : '1.8vw')};
	color: ${props => (props.strong ? '#333' : '#5f6a72')};
	white-space: pre-line;
	@media ${devices.mobileL} {
		font-size: ${props => (props.strong ? '15px' : '13px')};
		text-align: center;
	}
	@media ${devices.mobileM} {
		font-size: ${props => (props.strong ? '12px' : '9px')};
		text-align: center;
	}
`;

const Link = styled.button`
	font-family: Description;
	font-size: 2rem;
	color: #ada7cb;
`;

const Project = styled.div`
	font-family: Project;
	font-size: 3vw;
	color: #0036af;
	white-space: pre-line;
	@media ${devices.mobileL} {
		font-size: 25px;
		text-align: center;
	}
`;

const Header = styled.div`
	font-family: Project;
	font-size: 3vw;
	color: #3e4756;
	@media ${devices.mobileL} {
		margin-top: 30px;
		font-size: 15px;
		text-align: center;
	}
`;

export { Cover, Profile, Position, Title, Project, Link, Header, Description };
